import { render, staticRenderFns } from "./processList.vue?vue&type=template&id=f4d6a7a0&scoped=true"
import script from "./processList.vue?vue&type=script&lang=js"
export * from "./processList.vue?vue&type=script&lang=js"
import style0 from "./processList.vue?vue&type=style&index=0&id=f4d6a7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d6a7a0",
  null
  
)

export default component.exports